import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { FormattedMessage } from '../../util/reactIntl';
import { PrimaryButton, VerifiedUserMark, Logo, Tooltip } from '../../components';
import SectionIconsMaybe from './SectionIconsMaybe';
import { TiLightbulb } from 'react-icons/ti';
import { HiOutlineUsers } from 'react-icons/hi2';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { IoLanguage } from 'react-icons/io5';
import config from '../../config';

import css from './ProjectListingPage.css';

export const SectionHeadingComponent = props => {
  const {
    richTitle,
    hostLink,
    showContactUser,
    hasExistingProposal,
    existingProposalTransactionId,
    checkExistingProposalInProgress,
    user,
    onContactUser,
    publicData,
    applicationCount,
    iconsWrapperClassName,
    history,
  } = props;

  const authorPartOfFreedomly = user?.attributes?.profile?.metadata?.partOfFreedomly;

  const authorPublicData = user?.attributes?.profile?.publicData || {};
  const locationCountry = authorPublicData.locationCountry;
  const languageOptions =
    config.custom.filters.find(filter => filter.id === 'languages')?.config?.options || [];
  const languageLabels = (authorPublicData.languages || [])
    .map(key => languageOptions.find(option => option.key === key)?.label)
    .filter(Boolean);

  const handleViewApplication = () => {
    if (existingProposalTransactionId) {
      history.push(`/application/order/${existingProposalTransactionId}`);
    }
  };

  const contactButtonMaybe = !checkExistingProposalInProgress ? (
    showContactUser ? (
      <PrimaryButton rootClassName={css.contactButton} onClick={onContactUser}>
        <FormattedMessage id="ProjectListingsPage.sendApplicationButton" />
      </PrimaryButton>
    ) : hasExistingProposal ? (
      <PrimaryButton rootClassName={css.contactButton} onClick={handleViewApplication}>
        <FormattedMessage id="ProjectListingPage.viewApplicationButton" />
      </PrimaryButton>
    ) : null
  ) : null;

  const applicationCountMaybe =
    applicationCount > 0 ? (
      <div className={css.applicationCountRow}>
        <HiOutlineUsers className={css.applicationCountIcon} />
        <span className={css.applicationCountText}>
          <FormattedMessage
            id="ProjectListingPage.applicationCount"
            values={{ count: applicationCount }}
          />
        </span>
      </div>
    ) : null;

  return (
    <div className={css.sectionHeading}>
      <div className={css.sectionHeadingContainer}>
        <div className={css.heading}>
          <h1 className={css.title}>{richTitle}</h1>
          {authorPartOfFreedomly ? (
            <div className={css.partOfFreedomlySubtitle}>
              <FormattedMessage id="ProjectListingPage.partOfFreedomlySubtitle" />
            </div>
          ) : null}
          <div className={css.author}>
            <span className={css.authorName}>
              <FormattedMessage id="ListingPage.hostedBy" values={{ name: hostLink }} />
              <VerifiedUserMark user={user} />
            </span>
            {locationCountry ? (
              <span className={css.authorMetaItem}>
                <FaMapMarkerAlt className={css.authorMetaIcon} />
                {locationCountry}
              </span>
            ) : null}
            {languageLabels.length > 0 ? (
              <span className={css.authorMetaItem}>
                <IoLanguage className={css.authorMetaIcon} />
                <span>
                  {languageLabels.map((label, index) => (
                    <React.Fragment key={index}>
                      {index > 0 ? ', ' : null}
                      {label}
                    </React.Fragment>
                  ))}
                </span>
              </span>
            ) : null}
          </div>
        </div>
      </div>
      <SectionIconsMaybe publicData={publicData} wrapperClassName={iconsWrapperClassName} />
      <div className={css.estimatesNote}>
        <TiLightbulb className={css.estimatesNoteIcon} />
        <span className={css.estimatesNoteText}>
          <FormattedMessage id="ProjectListingPage.estimatesNote" />
        </span>
      </div>
      {applicationCountMaybe || contactButtonMaybe ? (
        <div className={css.sectionHeadingFooter}>
          {applicationCountMaybe}
          {contactButtonMaybe}
        </div>
      ) : null}
    </div>
  );
};

export default compose(withRouter)(SectionHeadingComponent);
